import { Inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as Actions from './reports.actions';
import { ReportApi, ReportTravelerDTO } from '@lkp/parking-sdk';
import { REPORT_API } from '../../providers/api.module';
import { tap } from 'rxjs';

export interface ReportsStateModel {
  reports: ReportTravelerDTO[];
}

@State<ReportsStateModel>({
  name: 'reports',
  defaults: {
    reports: [],
  },
})
@Injectable()
export class ReportsState {
  constructor(@Inject(REPORT_API) readonly reportApi: ReportApi) {}

  @Selector()
  static currentReports(state: ReportsStateModel) {
    return state.reports;
  }

  @Action(Actions.GetReport)
  getReport(
    context: StateContext<ReportsStateModel>,
    action: Actions.GetReport
  ) {
    const { fromDate, toDate } = action;

    return this.reportApi
      .getReportTravelers({
        fromDate: fromDate,
        toDate: toDate,
      })
      .pipe(
        tap((report) => {
          context.setState({ reports: report });
        })
      );
  }
}
